import { localApi } from "services/local";
import { SettingsResponse } from "./definitions";

const extendedApi = localApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsResponse, void>({
      query: () => "settings.json",
    }),
  }),
  overrideExisting: false,
});

export const { useGetSettingsQuery, usePrefetch } = extendedApi;
